<!--
 * @Author: zs
 * @Date: 2022-04-20 14:14:37
 * @LastEditTime: 2022-04-20 16:34:30
 * @Description:  截图组件
 * @FilePath: \smart-community\src\components\global\Hdetails.vue
-->
<template>
  <div class="cutImage" @mouseleave="showImgOper = false">
    <h-cropper
      v-if="cpnInfo"
      ref="cropperRef"
      :imgUrl="cpnInfo.base64"
      :overBool="true"
      :autoBack="true"
      mode="contain"
      @getImgAxiss="getImgAxiss"
      @imgFinish="imgFinish"
      @mouseenter="mouseEnter"
      @mouseup="mouseUp"
    ></h-cropper>
    <div
      class="selectBtn"
      v-if="showFeatureBtn"
      :style="{ top: featureBtnOffsetY, left: featureBtnOffsetX }"
    >
      <i
        class="iconfont icon-guanbi2"
        style="color: red; cursor: pointer"
        @click="closeReminder"
      ></i>
      <div
        v-for="item in searchImageSelect"
        :key="item.value"
        @click="clicksearchImageSelect(item.value)"
        class="featureBtn"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="operation" v-show="showImgOper">
      <div class="operation_cut" @click="screenShot">
        <div class="operation_cut_in">
          <i class="iconfont icon-jianqie"></i><span>截图搜索</span>
        </div>
      </div>
      <div class="operation_item">
        <span class="operation_conent" @click="backPlay">
          <i class="iconfont icon-zhibohuifang"></i>回放</span
        >
        <span
          class="operation_conent"
          style="margin-left: 12px"
          @click="downFile"
        >
          <i class="iconfont icon-xiazai"></i>下载</span
        >
      </div>
      <div class="operation_item">
        <span v-if="cpnInfo" class="operation_conent">{{
          moment(parseInt(cpnInfo.passTime)).format("YYYY-MM-DD HH:mm:ss")
        }}</span>
      </div>
    </div>
    <h-video-dialog
      v-if="showVideoDialog"
      v-model:visible="showVideoDialog"
      :videoData="videoData"
      :title="videoTitle"
    ></h-video-dialog>
  </div>
</template>

<script>
import {
  ref,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
} from "vue";
import moment from "moment";
import { url2ToBase } from "@/api/smartApplication/personSearchApi.js";
import util from "@util/js";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "cutImage",
  components: {},
  props: {
    itemInfo: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      showImgOper: false,
      showFeatureBtn: false,
      featureBtnOffsetX: "0px",
      featureBtnOffsetY: "0px",
      cpnInfo: null,
      getImgAxiss: null, //截取图片的位置
      searchImageSelect: [
        { name: "以脸搜脸", value: "1" },
        { name: "以人搜人", value: "2" },
        { name: "背影寻脸", value: "1" },
        { name: "特征搜人", value: "2" },
        { name: "机动车", value: "3" },
        { name: "非机动车", value: "4" },
      ],
      startCropTime: false, //true表示正在截图
      showVideoDialog: false,
      videoDialogData: null,
      videoTitle: "",
      videoData: null,
      getImgFinish: null,
    });
    const refData = toRefs(state);
    const cropperRef = ref(null);
    const router = useRouter();
    watchEffect(() => {
      state.cpnInfo = props.itemInfo;
      nextTick(() => {
        if (state.cpnInfo.fullUrl) {
          httpToBase64(state.cpnInfo.fullUrl);
        }
      });
    });
    //地址转base64
    const httpToBase64 = async (url) => {
      const params = {
        paths: [url],
      };
      const res = await url2ToBase(params);
      if (res.code == 0) {
        state.cpnInfo.base64 = "data:image/jpeg;base64," + res.data[0];
      }
    };
    //松开鼠标停止截图
    const mouseEnter = () => {
      if (!state.startCropTime) {
        state.showImgOper = true;
      }
    };
    //开始截图
    const screenShot = () => {
      console.log(cropperRef.value);
      state.startCropTime = true;
      cropperRef.value && cropperRef.value.startCrop();
      state.showImgOper = false;
    };
    //松开鼠标停止截图
    const mouseUp = () => {
      if (state.startCropTime) {
        cropperRef.value && cropperRef.value.cropEnd();
        state.showFeatureBtn = true;
        if (parseInt(state.getImgAxiss.x2) + 10 > 440) {
          state.featureBtnOffsetX = parseInt(state.getImgAxiss.x1) - 100 + "px";
        } else {
          state.featureBtnOffsetX = parseInt(state.getImgAxiss.x2) + 10 + "px";
        }
        state.featureBtnOffsetY = state.getImgAxiss.y1 + "px";
      }
    };

    //获取截图坐标
    const getImgAxiss = (axiss) => {
      state.getImgAxiss = axiss;
      console.log(state.getImgAxiss);
    };
    //base64图片
    const imgFinish = (base64) => {
      state.getImgFinish = base64;
    };

    //关闭选择
    const closeReminder = () => {
      state.showFeatureBtn = false;
      state.startCropTime = false;
      state.getImgAxiss = null;
      cropperRef.value && cropperRef.value.stopCrop();
    };
    //图片下载
    const downFile = () => {
      util.downImgFile(state.cpnInfo.fullUrl);
    };
    //回放
    const backPlay = () => {
      state.cpnInfo.deviceId = props.itemInfo.sourceId;
      state.videoData = state.cpnInfo;
      state.videoTitle = "视频回放";
      state.showVideoDialog = true;
    };
    //特征搜索
    const clicksearchImageSelect = (val) => {
      closeReminder();
      let routerData = router.resolve({
        path: "/trackQuery",
        query: { img: state.getImgFinish, type: val },
      });
      window.open(routerData.href, "_blank");
    };
    return {
      ...refData,
      moment,
      cropperRef,
      screenShot,
      getImgAxiss,
      imgFinish,
      mouseUp,
      closeReminder,
      mouseEnter,
      downFile,
      backPlay,
      clicksearchImageSelect,
    };
  },
});
</script>

<style lang="scss" scoped>
.cutImage {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .selectBtn {
    position: absolute;
    width: 90px;
    border: 1px solid rgba(0, 225, 255, 0.534);
    background: #263245;
    @include flex-col-c-s;
    z-index: 20;
    i {
      width: 100%;
      text-align: end;
      position: absolute;
      top: -5px;
      right: -5px;
    }

    .featureBtn {
      text-align: center;
      line-height: 34px;
      height: 34px;
      width: 100%;
      color: #fff;
      font-size: 14px;
      &:hover {
        background: rgba(0, 225, 255, 0.534);
        cursor: pointer;
      }
    }
  }
  .operation {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 50px;
    background-color: rgba($color: #000000, $alpha: 0.4);
    font-size: 14px;
    @include flex-row-e-c;
    .operation_cut {
      width: 90px;
      height: 90px;
      border: 1px solid rgba(0, 243, 255, 0.3);
      border-radius: 45px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      @include flex-col-c-c;
      cursor: pointer;
      background: rgba($color: #000000, $alpha: 0.5);
      .operation_cut_in {
        width: 80px;
        height: 80px;
        border-radius: 40px;
        @include flex-col-c-c;
        font-size: 14px;
        color: #fff;
        background: rgba(0, 225, 255, 0.534);
      }
    }
    .operation_item {
      width: 30%;

      .operation_conent {
        color: #fff;
        i {
          margin-right: 3px;
          color: #fff;
        }
        .icon-jianqie {
          font-size: 26px;
        }
      }

      .operation_conent:hover {
        cursor: pointer;
        color: #00fafa;
        i {
          color: #00fafa;
        }
      }
      margin: 0 6px;
    }
  }
  /deep/.cropper-box {
    background-color: #29436f;
  }
}
</style>